import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SHARE CAPITAL VERIFICATION
// Legacy: /AccountsApproval/VerifyShareCapital (+ VerifyShareCapitalGrid / VerifyShareCapitalView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — share capital updations pending at this role's level.
export const getVerifyShareCapitalGrid = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/VerifyShareCapitalGrid`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail: authorised / issued / paid-up capital added, uploaded document, MOID.
export const getVerifyShareCapitalView = async (refNo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/VerifyShareCapitalView`, { params: { Refno: refNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Existing approved capital, shown for comparison (legacy /Reports/Viewcapitalinfo).
export const getCapitalDetails = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetCapitaldetails`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spApproveShareCapital — success literal "Submitted"; action in Status).
export const approveShareCapital = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveShareCapital`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
